export const recordDuration = (secs: number) => {
  let hr: any = Math.floor(secs / 3600);
  let min: any = Math.floor((secs - (hr * 3600)) / 60);
  let sec: any = Math.floor(secs - (hr * 3600) - (min * 60));

  if (min < 10) {
      min = "0" + min;
  }

  if (sec < 10) {
      sec = "0" + sec;
  }

  return min + ':' + sec;
}

export const trimTime = (secs) => {
  let hr: any = Math.floor(secs / 3600);
  let min: any = Math.floor((secs - (hr * 3600)) / 60);
  let sec: any = secs - (hr * 3600) - (min * 60);

  if (hr < 10) {
      hr = "0" + hr;
  }
  
  if (min < 10) {
      min = "0" + min;
  }

  if (sec < 10) {
      sec = "0" + sec;
  }

  return hr + ':' + min + ':' + sec;
}